export enum ENVS {
  PROD = 'prod',
  QA = 'qa',
  UAT = 'uat',
  DEV = 'dev',
  DEV_FEATURE1 = 'dev_feature1'
}
